var _g;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconMsWordLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconMsWord",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _g || (_g = /*#__PURE__*/React.createElement("g", {
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M1251.654 0c44.499 0 88.207 18.07 119.718 49.581l329.223 329.224c31.963 31.962 49.581 74.54 49.581 119.717V1920H169V0Zm-66.183 112.941H281.94V1807.06h1355.294V564.706H1185.47V112.94Zm112.94 23.379v315.445h315.445L1298.412 136.32Z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M959.588 338.824v451.764H507.824V338.824h451.764zm-112.94 112.94H620.764v225.883h225.882V451.765zm-338.824 564.707h903.529V903.529h-903.53zm0 451.764h790.588v-112.94H507.824zm0-225.882h677.647v-112.941H507.824z"
    }))));
  }
}
IconMsWordLine.glyphName = 'ms-word';
IconMsWordLine.variant = 'Line';
IconMsWordLine.displayName = 'IconMsWordLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMsWordLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMsWordLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMsWordLine;
export { IconMsWordLine };